import { Privacy } from '../../components/service/accounts/PrivacyTerms';
import { usePrivacyData } from '../../services';
export const PrivacyPageView = () => {
  const privacy = usePrivacyData();
  if (!privacy.isSuccess) {
    return <></>;
  }
  return <Privacy data={privacy.data} data-sentry-element="Privacy" data-sentry-component="PrivacyPageView" data-sentry-source-file="privacy.tsx" />;
};